import classNames from "classnames";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import styles from "./discardApplyButtons.css";

interface Props {
  onDiscard: () => any;
  onApply?: () => void;
  withDescription?: boolean;
  hidden?: boolean;
  applyDisabled?: boolean;
  allDisabled?: boolean;
  alignToLeft?: boolean;
}

export const DiscardApplyButtons: React.VFC<Props> = ({
  onDiscard,
  withDescription,
  hidden,
  applyDisabled,
  onApply,
  alignToLeft,
  allDisabled
}) => (
  <div>
    <div
      className={classNames(styles["buttons-container"], {
        [styles.hidden]: hidden,
        [styles.toLeft]: alignToLeft
      })}
    >
      <AgentButton buttonStyle={"outlined secondary"} onClick={onDiscard} disabled={allDisabled}>
        <L10n id={"settings.discard"} />
      </AgentButton>
      <AgentButton disabled={applyDisabled || allDisabled} onClick={onApply}>
        <L10n id={"settings.apply"} />
      </AgentButton>
    </div>
    {withDescription && (
      <div className={classNames(styles.description, { [styles.hidden]: hidden })}>
        <L10n id={"settings.orPressEnter"} />
      </div>
    )}
  </div>
);
